import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../../components/header/Header';
import Footer from '../../../components/footer/Footer';
import HeroCarousel from '../../../components/carousel/HeroCarousel';
import img1 from '../../../assets/attendenceCarousel.png';
import Breadcrumb from '../../../shared/components/Breadcrumb';
import AttendanceDashboard from './AttendanceDashboard';
import StudentAttendanceDashboard from './StudentAttendanceDashboard';

export default function AttendancePage() {
  const carouselImages = [img1];
  const location = useLocation();
  // Get role from query param (?role=teacher or ?role=student)
  const params = new URLSearchParams(location.search);
  const role = params.get('role') === 'student' ? 'student' : 'teacher'; // default to teacher

  // Placeholder for API integration based on role
  // useEffect(() => {
  //   fetchDataForRole(role);
  // }, [role]);

  return (
    <div className="min-h-screen flex flex-col gap-0 bg-[#f5f5f7]">
      <Header />
      <HeroCarousel images={carouselImages} autoRotateInterval={3000} />
      <div className="w-full max-w-7xl px-4 -pt-2 -sm:pt-3">
        <Breadcrumb />
      </div>
      <main className="flex-grow w-full flex flex-col items-center justify-center py-4 sm:py-6 md:py-8">
        {role === 'student' ? <StudentAttendanceDashboard /> : <AttendanceDashboard role={role} /> }
      </main>
      <Footer />
    </div>
  );
} 
